export const eModeCategoryIdToName = {
  0: 'No E-Mode',
  1: 'HYPE Correlated',
  2: 'USD Correlated',
} as const
